import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-xxl-4" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-6 col-xxl-12" }
const _hoisted_6 = { class: "col-md-6 col-xxl-12" }
const _hoisted_7 = { class: "col-xxl-8" }
const _hoisted_8 = { class: "row justify-content-center" }
const _hoisted_9 = { class: "col-lg-4 col-md-6" }
const _hoisted_10 = { class: "col-lg-4 col-md-6" }
const _hoisted_11 = { class: "col-lg-4 col-md-6" }
const _hoisted_12 = { class: "row justify-content-center" }
const _hoisted_13 = { class: "col-xxl-5" }
const _hoisted_14 = { class: "col-xxl-7" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-lg-6" }
const _hoisted_17 = { class: "col-lg-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActiveTotalProperty = _resolveComponent("ActiveTotalProperty")!
  const _component_RevenueChart = _resolveComponent("RevenueChart")!
  const _component_NewListingsSoldPropertiesChart = _resolveComponent("NewListingsSoldPropertiesChart")!
  const _component_PropertiesForSaleChart = _resolveComponent("PropertiesForSaleChart")!
  const _component_PropertiesForRentChart = _resolveComponent("PropertiesForRentChart")!
  const _component_NewCustomers = _resolveComponent("NewCustomers")!
  const _component_MostSalesLocation = _resolveComponent("MostSalesLocation")!
  const _component_RecentProperty = _resolveComponent("RecentProperty")!
  const _component_RentalIncomeChart = _resolveComponent("RentalIncomeChart")!
  const _component_SocialSearchChart = _resolveComponent("SocialSearchChart")!
  const _component_TopProperty = _resolveComponent("TopProperty")!
  const _component_CustomerReviews = _resolveComponent("CustomerReviews")!
  const _component_LatestTransaction = _resolveComponent("LatestTransaction")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_ActiveTotalProperty)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_RevenueChart)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_NewListingsSoldPropertiesChart)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_PropertiesForSaleChart)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_PropertiesForRentChart)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_NewCustomers)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_MostSalesLocation),
        _createVNode(_component_RecentProperty)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_RentalIncomeChart),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_SocialSearchChart),
            _createVNode(_component_TopProperty)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_CustomerReviews)
          ])
        ])
      ])
    ]),
    _createVNode(_component_LatestTransaction)
  ]))
}